<template>
  <FontAwesomeIcon :icon="['fasr', 'sort-down']" />
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
</script>
